var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPublishedProductsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 25.3333C5.82423 24.2801 7.89356 23.7256 10 23.7256C12.1064 23.7256 14.1758 24.2801 16 25.3333C17.8242 24.2801 19.8936 23.7256 22 23.7256C24.1064 23.7256 26.1758 24.2801 28 25.3333",
    stroke: "#F3F4F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C5.82423 6.94678 7.89356 6.3923 10 6.3923C12.1064 6.3923 14.1758 6.94678 16 8C17.8242 6.94678 19.8936 6.3923 22 6.3923C24.1064 6.3923 26.1758 6.94678 28 8",
    stroke: "#F3F4F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8V25.3333",
    stroke: "#F3F4F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8V25.3333",
    stroke: "#F3F4F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 8V25.3333",
    stroke: "#F3F4F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublishedProductsWhite);
export default __webpack_public_path__ + "static/media/Icon_PublishedProducts_White.8c4bd6078cf780352e570c7e5ed3aa1c.svg";
export { ForwardRef as ReactComponent };